import React, { useState, useRef, useEffect } from "react";

export default React.memo(function ReflexionBox() {
  const [text, setText] = useState("");
  const textareaRef = useRef(null);

  // Cargar texto guardado al montar
  useEffect(() => {
    const saved = localStorage.getItem("reflexion-text");
    if (saved) setText(saved);
    if (textareaRef.current) textareaRef.current.focus();
  }, []);

  // Guardar en localStorage cada vez que cambia
  useEffect(() => {
    localStorage.setItem("reflexion-text", text);
  }, [text]);

  return (
    <div className="reflexion-box-container">
      <textarea
        ref={textareaRef}
        className="reflexion-box-textarea thick-caret"
        placeholder="🖋️"
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={8}
      />
    </div>
  );
});
